import React from 'react';
import { useSelector } from 'react-redux';
import { DEBUG_TOOLS } from '../../debug/store/debugToolConstants';
import { debugToolProperty } from '../../debug/store/debugToolSelector';

import './MobileDebug.scss';

const MobileDebug = () => {
    const simulateMobileKeyboard = useSelector(debugToolProperty(DEBUG_TOOLS.MOBILE, 'simulateMobileKeyboard'));
    const simulateCapacitorSafeAreaBottom = useSelector(
        debugToolProperty(DEBUG_TOOLS.MOBILE, 'simulateCapacitorSafeAreaBottom'),
    );

    return (
        <>
            {simulateMobileKeyboard && <div className="mobile-debug-container debug-mobile-keyboard"></div>}
            {simulateCapacitorSafeAreaBottom && (
                <div className="mobile-debug-container debug-capacitor-safe-area-bottom"></div>
            )}
        </>
    );
};

export default MobileDebug;
